module.exports = __webpack_public_path__ + "static/img/services-1.05f10c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/services-1.png
// module id = ELKx
// module chunks = 1